export default __webpack_public_path__ + "static/media/datenschutzerklaerunginterb2bike.cec55934.pdf";